module.exports = __webpack_public_path__ + "static/media/client29.d2a04be4.webp";